import GroupEditor from './GroupEditor'

export default GroupEditor
